import classNames from "classnames";
import { useMemo } from "react";

import { ignoreAttribute } from "@ascendnow/shared";

import styles from "./AscStepsProgressBar.module.scss";

export interface AscStepsProgressBarProps {
  value: number;
  max: number;
  fullWidth?: boolean;
  className?: string;
}

export default function AscStepsProgressBar({
  value = 0,
  max = 100,
  fullWidth = false,
  className,
}: AscStepsProgressBarProps) {
  const steps = useMemo(() => {
    const _steps = [];

    for (let i = 1; i <= max; i++) {
      _steps.push(<AscProgressStep active={i <= value} key={i} />);
    }

    return _steps;
  }, [max, value]);

  return (
    <div
      className={classNames(
        styles.ground,
        {
          [styles.fullWidth]: fullWidth,
        },
        className
      )}
      {...ignoreAttribute.contrast}
    >
      {steps}
    </div>
  );
}

interface AscProgressStepProps {
  active: boolean;
}
function AscProgressStep({ active }: AscProgressStepProps) {
  return (
    <div
      className={classNames(styles.progressStep, {
        [styles.active]: active,
      })}
      {...ignoreAttribute.contrast}
      {...ignoreAttribute.contrast}
    />
  );
}
